import React from "react";
import {useTranslation} from "react-i18next";

import {formatCurrency, formatDate} from "../../utils/utils";

import "./StatisticsPage.scss";


const CommissionsListElement = (props) => {
  const { t } = useTranslation();

  let campaign = props.campaigns.find(item => item.id === props.commission.campaign_id);
  if (!campaign)
    campaign = props.campaigns[0];

  return (
    <div className={'commissions-list__element'}>
      <div>
        {formatDate(props.commission.time)}
      </div>
      <div>
        {campaign.display_name}
      </div>
      <div>
        {formatCurrency(props.commission.amount)}
      </div>
      <div className={props.commission.status}>
        {t("CommissionsBox.Status." + props.commission.status)}
      </div>
    </div>
  );
}

export default CommissionsListElement;